module.exports = __webpack_public_path__ + "img/venuethree-hzq.d9177674.png";